import axios from 'axios';

import { env } from 'services/runtimeEnv';

export function getHistoricRatesBetweenCurrencies(data, cancelToken) {
  const query = new URLSearchParams({ ...data, access_key: env('FOREX_KEY') }).toString();

  return axios.get(`https://api.exchangeratesapi.io/v1/timeseries?${query}`, { cancelToken });
}
